import axios from 'axios';
import { captureException } from '@sentry/nextjs';
import { CmsCategoryCodeEnum, CmsProductSefUrlEnum } from '~/src/models/enums/cms.enum';
import { apiKeyCmsArticlesDictionary, defaultUrlCmsArticlesDictionary } from '~/src/repositories/cms/api-urls';
import { getMappedDocumentationFilesData } from '~/src/repositories/cms/shared/utils/cms.utils';
import { getRequestUrlHelper } from '~/src/helpers/get-request-url.helper';
import { API_HOST_CMS_ENV } from '~/src/params';
import type {
    ArticlesDictionaryProps,
    CmsMappedArticlesAllTypes,
    CmsMappedArticlesInterface,
} from '~/src/repositories/cms/types/cms.articles.types';

//TODO потребуется рефакторинг
export const getArticlesDictionaryWithProductUrlInTheEnd = async ({
    isSSR,
    categoryCode,
    articleSefUrl,
    productSefUrl = CmsProductSefUrlEnum.MTS_AGENTS,
}: ArticlesDictionaryProps): Promise<CmsMappedArticlesAllTypes> => {
    const url = getRequestUrlHelper({
        isSSR: isSSR,
        apiKey: apiKeyCmsArticlesDictionary,
        defaultUrl: defaultUrlCmsArticlesDictionary,
        apiHost: API_HOST_CMS_ENV,
    });

    const config = {
        params: {
            articleSefUrl,
            categoryCode,
            productSefUrl,
        },
    };

    try {
        const { data } = await axios.get<CmsMappedArticlesInterface>(url, config);
        return data;
    } catch (error: unknown) {
        // eslint-disable-next-line no-console
        console.log(error);
        captureException(error);
        return { cmsFailed: true };
    }
};

export const getInstructionDataViaApi = async (
    articleSefUrl?: string,
    categoryCode?: CmsCategoryCodeEnum,
    productSefUrl?: CmsProductSefUrlEnum,
) => {
    try {
        const { data } = await axios.get(
            `/${apiKeyCmsArticlesDictionary}?articleSefUrl=${articleSefUrl}&categoryCode=${categoryCode}&productSefUrl=${productSefUrl}`,
        );

        if ('cmsFailed' in data) {
            return { cmsFailed: true };
        }
        return getMappedDocumentationFilesData(data).documentationLink;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Instruction fetch error:', error);
        return { cmsFailed: true };
    }
};

export const getInstructionData = async (isSSR: boolean, categoryCode: CmsCategoryCodeEnum, articleSefUrl?: string) => {
    const data = await getArticlesDictionaryWithProductUrlInTheEnd({
        isSSR,
        categoryCode,
        articleSefUrl,
    });

    if ('cmsFailed' in data) {
        return { cmsFailed: true };
    }
    return getMappedDocumentationFilesData(data).documentationLink;
};
